export function getType(actionCreator) {
    if (actionCreator == null) {
        throw new Error('first argument is missing');
    }
    if (actionCreator.getType == null) {
        throw new Error('first argument is not an instance of "typesafe-actions"');
    }
    return actionCreator.getType();
}
//# sourceMappingURL=get-type.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/typesafe-actions/es5-module/get-type.js
// module id = 1011
// module chunks = 9